module.exports = __webpack_public_path__ + "img/mobile.8be3d0d6.png";